import { render, staticRenderFns } from "./CbsDataQuery.vue?vue&type=template&id=05d53be2&scoped=true"
import script from "./CbsDataQuery.vue?vue&type=script&lang=js"
export * from "./CbsDataQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d53be2",
  null
  
)

export default component.exports